export enum SavedFilterType {
    Contract = "contract",
    Document = "document",
}

export interface IGetSavedListingFiltersResponseDTO {
    id: number;
    name: string;
    public: boolean;
    type: SavedFilterType;
    user_id: number;
    /**
     * Filters definition
     */
    value ;
}

export interface ICreateSavedFilterRequestDTO {
    name: string;
    public: boolean;
    type: SavedFilterType;
    /**
     * Filters definition
     */
    value;
}

export interface IUpdateSavedFilterRequestDTO{
    name: string;
    public: boolean;
    type: SavedFilterType;
    /**
     * Filters definition
     */
    value: { [key: string]: unknown };
}

export interface IUpdateSavedFilterResponseDTO{
    id: number;
    name: string;
    public: boolean;
    type: SavedFilterType;
    user_id: number;
    /**
     * Filters definition
     */
    value: { [key: string]: unknown };
}
